import { render, staticRenderFns } from "./payView.vue?vue&type=template&id=1c517bd7&scoped=true"
import script from "./payView.vue?vue&type=script&lang=js"
export * from "./payView.vue?vue&type=script&lang=js"
import style0 from "./payView.vue?vue&type=style&index=0&id=1c517bd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c517bd7",
  null
  
)

export default component.exports